import { render, staticRenderFns } from "./VideoRangeSlider.vue?vue&type=template&id=70529fad&scoped=true&"
import script from "./VideoRangeSlider.vue?vue&type=script&lang=js&"
export * from "./VideoRangeSlider.vue?vue&type=script&lang=js&"
import style0 from "./VideoRangeSlider.vue?vue&type=style&index=0&id=70529fad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70529fad",
  null
  
)

export default component.exports